import { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const FairePayClarityV2Page = withCompass(
  () => import("../../pages/FairePayClarityV2Page")
);
const FairePayInvoiceClarityPage = withCompass(
  () => import("../../pages/FairePayInvoiceClarityPage")
);
const FairePayInvoiceIntegrationV1Page = withCompass(
  () => import("../../pages/FairePayInvoiceIntegrationV1Page")
);
const PayAsYouGoIssueExplorationPage = lazy(
  () => import("../../workspace/hy/pay-as-you-go-issue-exploration/Page")
);

export function HarshaYeddanapudyRoutes() {
  return (
    <Switch>
      <Redirect
        exact
        from="/hy/faire-pay-invoice-clarity-v2"
        to="/hy/faire-pay-clarity-v2"
      />
      <Route
        path="/hy/pay-as-you-go-issue-exploration"
        component={PayAsYouGoIssueExplorationPage}
      />
      <Route
        path="/hy/faire-pay-clarity-v2"
        component={FairePayClarityV2Page}
      />
      <Route
        path="/hy/faire-pay-invoice-clarity"
        component={FairePayInvoiceClarityPage}
      />
      <Route
        path="/hy/faire-pay-invoice-integration-v1"
        component={FairePayInvoiceIntegrationV1Page}
      />
    </Switch>
  );
}

export const slug = "hy";
